import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 11a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m-5 -5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3","key":"svg-0"}]]

const IconDice2Filled = createReactComponent('filled', 'dice-2-filled', 'Dice2Filled', __iconNode);

export default IconDice2Filled;